// Create initial state
import { CountryAddress } from "@/configs/jtTypes";
import { Order } from "@/configs/orders";
import { AddressMode } from "@/libs/address";
import { getAddressMode } from "@/libs/localStorage";

export const state = {
  darkMode: false,
  countryAddresses: [] as CountryAddress[],
  orderLibrary:[] as Order[],
  addressMode: getAddressMode() as AddressMode,
};

// Declare state
export type State = typeof state;
